(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3MemberIntegration', {
            templateUrl: 'app/member-admin/member-integration/member-integration.component.html',
            controller: MemberIntegrationComponent,
            bindings: {
                individualId: '<',
                integrations: '<',
                sources: '<'
            }
        });

    var copy = angular.copy,
        noop = angular.noop;

    MemberIntegrationComponent.$inject = ['Member', 'alert', 'confirm', 'memberAdminResources'];
    function MemberIntegrationComponent(Member, alert, confirm, resources) {
        var ctrl = this;

        ctrl.insert = insert;
        ctrl.edit = edit;
        ctrl.save = save;
        ctrl.remove = remove;
        ctrl.cancel = cancel;
        ctrl.sourceChange = sourceChange;

        ////////////////////////////////////////

        function insert() {
            var integration = { individualId: ctrl.individualId };
            ctrl.integrations.push(integration);
            edit(integration);
        }

        function edit(integration) {
            integration.$clone = angular.copy(integration);
        }

        function save(integration, form) {
            var clone = integration.$clone;
            if (form.$valid)
                Member.saveIntegration({ id: ctrl.individualId }, clone, success, error, true);

            function success(data) {
                copy(data, integration);
                delete integration.$clone;
            }

            function error() {
                alert.error(resources.saveIntegrationFailed);
            }
        }

        function remove(integration) {
            confirm(resources.confirmDeleteIntegration).then(remove, noop);

            function remove() {
                Member.deleteIntegration({ id: ctrl.individualId }, integration, success, error, true);

                function success() {
                    removeFromArray(integration);
                }

                function error() {
                    alert.error(resources.deleteIntegrationFailed);
                }
            }
        }

        function cancel(integration) {
            delete integration.$clone;
            if (!integration.oldSourceId)
                removeFromArray(integration)
        }

        function sourceChange(e, integration) {
            integration.$clone.sourceName = e.target.options[e.target.selectedIndex].text;
        }

        function removeFromArray(integration) {
            var index = ctrl.integrations.indexOf(integration);
            if (index != -1)
                ctrl.integrations.splice(index, 1);
        }
    }
})();